module.exports = __webpack_public_path__ + "img/line.ba3ded59.svg";